import styled from "styled-components";
import Select from "react-select";

export const AsideSelectForm = styled(Select)`
  .aside-form-select__control {
    background: transparent;
    border: none;
    border-bottom: 1px solid rgb(231, 231, 235);
    border-radius: 0;
    box-shadow: none;
    color: rgb(101, 101, 101);
    font-size: 14px;
    outline: none;
    width: 100%;
    @media screen and (max-width: 560px) {
      padding: 0;
    }
  }
  .aside-form-select__control--is-focused {
    border-color: ${props => props.empresa.palleta.cor_primaria};
    /* border-color: rgb(231, 231, 235); */
  }
  .aside-form-select__value-container {
    color: black;
    font-weight: 400;
    padding: 0;
    .aside-form-select__input {
      color: black;
    }
    .css-b8ldur-Input {
      color: black;
    }
    .css-1g6gooi {
      color: black;
    }
  }
  .aside-form-select__placeholder {
    color: #656565;
    font-weight: 400;
    @media screen and (max-width: 560px) {
      padding: 0;
      margin: 0;
    }
  }
  .aside-form-select__indicator-separator {
    display: none;
  }
  .aside-form-select__clear-indicator,
  .aside-form-select__dropdown-indicator {
    padding: 8px 2px;
  }
  .aside-form-select__menu {
    border-radius: 0 0 4px 4px;
    .aside-form-select__option {
      color: #1a1a1a;
      padding: 10px;
      &:hover {
        background-color: #99999950;
        color: #1a1a1a;
      }
    }
    .aside-form-select__option--is-selected {
      background-color: ${props => props.empresa.palleta.cor_primaria};
      color: white;
    }
    .aside-form-select__option--is-focused {
      background-color: ${props => props.empresa.palleta.cor_primaria}80;
    }
  }
`;
// theme={(theme) => ({
//   ...theme,
//   borderRadius: 0,
//   colors: {
//     ...theme.colors,
//     primary25: 'hotpink',
//     primary: 'black',
//   },
// })}

export default AsideSelectForm;
